import React from "react";
import { Container, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { FONT_GABRIOLA } from "../common/constant";

const Testimonials = () => {
  return (
    <Container
      maxWidth="xl"
      id="testimonials"
      sx={{ pl: "0 !important", pr: "0 !important", my: 10 }}
    >
      <Box
        sx={{
          margin: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          mt: 5,
          paddingX: 2,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontFamily: FONT_GABRIOLA,
            textAlign: "center",
            color: "#444444",
            mb: 2,
          }}
        >
          Looking to elevate the aesthetic of your space!
        </Typography>
        <Typography
          variant="h6"
          sx={{ textAlign: "center", fontWeight: 400, color: "#716D64" }}
        >
          Have a question for us? Let's talk. <br /> For all project inquires,
          please email <br />{" "}
          <Link
            style={{
              color: "#716D64",
            }}
            to="mailto:sakshi@miraedesigns.in"
          >
            sakshi@miraedesigns.in
          </Link>{" "}
          with the subject NEW PROJECT
        </Typography>
      </Box>
    </Container>
  );
};

export default Testimonials;
